import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import Routes from "routing/Routes";
import * as SecurityRoutes from "security-app/routing/Routes";
import { Alert, Button, Table as BaseTable } from "components/bootstrap";
import { IfPermitted } from "components/common";
import { Col, SmallNavTabs } from "common/components";
const Table = styled(BaseTable)`
  margin: 16px 0;
`;
const RoundButton = styled(Button)`
  border-radius: 4px;
`;
const META_BY_ENTITY_TYPE = {
  event_definitions: {
    readableType: "Event Definition",
    permission: (eventDefinitionId) => `eventdefinitions:edit:${eventDefinitionId}`,
    linkURL: (definitionId) => Routes.ALERTS.DEFINITIONS.edit(definitionId),
    linkLabel: "View"
  },
  anomaly_detectors: {
    readableType: "Anomaly Detector",
    permission: () => "anomaly_configuration:read",
    linkURL: () => SecurityRoutes.default.ANOMALIES.DETECTORS.LIST,
    linkLabel: "View"
  }
};
const TABS = [
  {
    id: "event_definitions",
    Label: () => /* @__PURE__ */ React.createElement("span", null, META_BY_ENTITY_TYPE.event_definitions.readableType)
  },
  {
    id: "anomaly_detectors",
    Label: () => /* @__PURE__ */ React.createElement("span", null, META_BY_ENTITY_TYPE.anomaly_detectors.readableType)
  }
];
function AssocEntities({ associatedEntities }) {
  const [activeTab, setActiveTab] = useState(TABS[0].id);
  return /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(SmallNavTabs, { tabs: TABS, activeTab, onClick: (tabId) => setActiveTab(tabId) }), associatedEntities[activeTab].length > 0 ? /* @__PURE__ */ React.createElement(Table, { condensed: true }, /* @__PURE__ */ React.createElement("tbody", null, associatedEntities[activeTab].map((assocEntity) => /* @__PURE__ */ React.createElement("tr", { key: assocEntity.id }, /* @__PURE__ */ React.createElement("td", null, assocEntity.title), /* @__PURE__ */ React.createElement("td", { style: { textAlign: "right" } }, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: META_BY_ENTITY_TYPE[activeTab].permission(assocEntity.id) }, /* @__PURE__ */ React.createElement(
    RoundButton,
    {
      bsSize: "xs",
      href: META_BY_ENTITY_TYPE[activeTab].linkURL(assocEntity.id),
      target: "_blank"
    },
    META_BY_ENTITY_TYPE[activeTab].linkLabel
  ))))))) : /* @__PURE__ */ React.createElement(Alert, { style: { width: "100%" } }, "No ", META_BY_ENTITY_TYPE[activeTab].readableType, "s"));
}
export default AssocEntities;
